import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';

import { ActivatedRoute, Router, RouterLinkActive } from '@angular/router';
import { AnimationOptions } from 'ngx-lottie';
import { map, Subscription, switchMap } from 'rxjs';
import { BEAccount } from 'src/interfaces/account';
import { FullScreenDialogConfig } from '../_config/full-screen-dialog-config';
import { AuthService } from '../_core/services/auth.service';
import { DialogService } from '../_core/services/dialog.service';
import { IconService } from '../_core/services/icon.service';
import { PraticaProgressService } from '../_core/services/pratica-progress.service';
import { PraticaAction, PraticaEvent } from '../pratica/models/pratica-event';
import { PraticaSection } from '../pratica/models/pratica-section';
import { Slice } from './models/slice';
import { StatoPratica } from '../../interfaces/pratica';
import { Overlay } from '@angular/cdk/overlay';
import { MatIconButton } from '@angular/material/button';
import { TransfersRecapComponent } from '../transfers-recap/transfers-recap.component';
import { ProductService } from '../_core/services/product.service';
import { KpiFactory } from '../requests/models/kpi-factory';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  @ViewChild('historyButton') historyButton?: MatIconButton;
  @ViewChildren('border') border?: QueryList<ElementRef<HTMLDivElement>>;
  @Input() isReadyForSignature = true;
  @Input() slices: Slice[] = [];
  @Input() pieIcons: string[] = [];

  @Output() praticaEvent = new EventEmitter<PraticaEvent>();

  readonly PraticaSection = PraticaSection;
  readonly StatoPratica = Object.freeze(StatoPratica);

  taskManagerIsOpen = false;

  profile?: BEAccount;
  saveSubscription?: Subscription;

  name: string = '';
  surname: string = '';

  get score$() {
    return this.productService.analisiCreditoProduct$.pipe(
      map((prod) => KpiFactory.roundNumbers(prod?.kpi?.Score))
    );
  }

  @ViewChildren(RouterLinkActive) routerLinks?: QueryList<RouterLinkActive>;
  constructor(
    public praticaProgressService: PraticaProgressService,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private dialogService: DialogService,
    private overlay: Overlay,
    private router: Router,
    private iconService: IconService,
    private productService: ProductService
  ) {
    this.iconService.getIcons([
      'save',
      'history',
      'exit',
      'transfers-recap',
      'edit',
    ]);
  }

  ngOnInit(): void {
    //timer(4000).subscribe((_) => (this._isCompleted = true));
    this.getProfile();
    this.name = this.profile?.nome.substring(0, 1) || '';
    this.surname = this.profile?.cognome.substring(0, 1) || '';

    this.iconService.getIcons(this.pieIcons);
  }

  ngOnDestroy(): void {
    this.saveSubscription?.unsubscribe();
  }

  getProfile() {
    this.saveSubscription = this.authService.me$
      .pipe(map((res) => (this.profile = res.data)))
      .subscribe();
  }

  showHistory() {
    this.taskManagerIsOpen = !this.taskManagerIsOpen;
  }

  showRecap() {
    this.dialogService
      .open(TransfersRecapComponent, {
        ...FullScreenDialogConfig,
        data: {
          pratica: this.praticaProgressService.selectedPratica,
        },
      })
      .afterClosed()
      .pipe(switchMap((_) => this.praticaProgressService.getPratica()))
      .subscribe();
  }

  navigate(route: PraticaEvent) {
    this.praticaEvent.emit(route);
  }

  get active() {
    let path: string | undefined = undefined;
    if (this.praticaProgressService.isOutcome) {
      path = this.activatedRoute.snapshot.firstChild?.routeConfig?.path;
    } else {
      path =
        this.activatedRoute.snapshot.firstChild?.firstChild?.routeConfig?.path;
    }
    return path || '';
  }

  save() {
    this.praticaEvent.emit(PraticaAction.SAVE);
  }

  saveClose() {
    this.praticaEvent.emit(PraticaAction.CLOSE);
  }

  logout() {
    this.authService.logout();
  }

  options: AnimationOptions = {
    path: '/assets/animations/signature-spinner.json',
    loop: false,
  };

  confirm() {
    this.praticaEvent.emit(PraticaAction.CONFIRM);
  }

  onClose() {
    this.taskManagerIsOpen = false;
  }

  goToPraticaDetail() {
    this.router.navigate(['detail', 'applicant'], {
      relativeTo: this.activatedRoute,
      preserveFragment: true,
    });
  }
}
